export const yellow = [
  '#F6C35D1A',
  '#F6C35D33',
  '#F6C35D66',
  '#F6C35D99',
  '#F6C35DCC'
]

export const ocherA = [
  '#D97F261A',
  '#D97F2633',
  '#D97F2666',
  '#D97F2699',
  '#D97F26CC'
]

export const red = [
  '#EB65651A',
  '#EB656533',
  '#EB656566',
  '#EB656599',
  '#EB6565CC'
]

export const ocherB = [
  '#9F4C111A',
  '#9F4C1133',
  '#9F4C1166',
  '#9F4C1199',
  '#9F4C11CC'
]

export const alertColors = {
  yellow,
  ocherA,
  red,
  ocherB
}
